<div class="row g-3">

  <!-- Write a note -->
  <div class="col-12 col-xl-6">
    <div class="student-card p-3 p-md-4 h-100">
      <p class="fs-20 fw-800 color-gray-950 mb-3">
        <i class="bi bi-journal-text color-brand-primary me-2"></i>{{'students.meeting_notes.private.create_title'|translate}}
      </p>

      <form [formGroup]="fg" (ngSubmit)="onSubmit()">
        <label class="fs-xsmall fw-800 color-gray-500 mb-2 d-block">
          {{'students.meeting_notes.private.summary'|translate|uppercase}}
        </label>

        <textarea
          class="note-textarea w-100" rows="6" formControlName="content"
          [maxlength]="maxLength"
          [placeholder]="'students.meeting_notes.private.summary_placeholder'|translate"></textarea>

        <div class="d-flex justify-content-between align-items-center mt-1">
          <div class="form-errors" *ngIf="isSubmitted && fg.get('content')?.errors">
            <p class="mb-0">{{'errors.required'|translate}}</p>
          </div>
          <span class="fs-xsmall fw-400 color-gray-400 ms-auto">{{remainingLength()}}</span>
        </div>

        <app-gray-button
          class="d-block mt-3"
          type="submit" color="primary" [weight]="800" padding="p-2" customClass="fs-normal"
          [isLoading]="isSaving" [disabled]="isSaving"
          [text]="'students.meeting_notes.private.save'|translate"></app-gray-button>
      </form>

      <p class="fs-small fw-400 color-gray-500 mb-0 mt-3">
        <i class="bi bi-lock me-1"></i>{{'students.meeting_notes.private.privacy'|translate}}
      </p>
    </div>
  </div>

  <!-- Past notes -->
  <div class="col-12 col-xl-6">
    <div class="student-card p-3 p-md-4 h-100">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p class="fs-20 fw-800 color-gray-950 mb-0">{{'students.meeting_notes.private.history_title'|translate}}</p>
        <span class="fs-xsmall fw-400 color-gray-400" *ngIf="total">
          {{'students.meeting_notes.private.total'|translate: {count: total} }}
        </span>
      </div>

      <app-gray-text-input
        customClass="compact-input"
        [placeholder]="'students.meeting_notes.private.search'|translate"
        [formControl]="searchControl"></app-gray-text-input>

      <ngx-skeleton-loader
        *ngIf="isLoading && !notes.length" count="3" appearance="line"
        [theme]="{height: '96px', 'border-radius': '12px', margin: '12px 0 0 0'}"/>

      <div class="note-item p-3 mt-3" *ngFor="let note of notes">
        <div class="d-flex align-items-start justify-content-between">
          <p class="fs-xsmall fw-800 color-brand-primary-700 mb-1">
            {{note.createdAt | date: 'd MMMM EEEE'|uppercase}}
          </p>

          <div class="d-flex align-items-center" *ngIf="editingNoteId !== note.id">
            <a class="note-action clickable color-gray-400 ms-2" (click)="startEdit(note)"
               [ngbTooltip]="'buttons.edit'|translate" container="body">
              <i class="bi bi-pencil"></i>
            </a>
            <a class="note-action clickable color-gray-400 ms-2" (click)="confirmDelete(note)"
               [ngbTooltip]="'buttons.remove'|translate" container="body">
              <i class="bi bi-trash"></i>
            </a>
          </div>
        </div>

        <p class="fs-small fw-400 color-gray-950 mb-0 note-content" *ngIf="editingNoteId !== note.id">
          {{note.content}}
        </p>

        <ng-container *ngIf="editingNoteId === note.id">
          <textarea class="note-textarea w-100 mt-1" rows="5" [formControl]="editControl"
                    [maxlength]="maxLength"></textarea>

          <div class="d-flex justify-content-end mt-2">
            <app-gray-button
              color="stroke" [fullWidth]="false" padding="py-1 px-3" [weight]="500"
              customClass="fs-small me-2"
              [text]="'buttons.give_up'|translate" (click)="cancelEdit()"></app-gray-button>

            <app-gray-button
              color="primary" [fullWidth]="false" padding="py-1 px-3" [weight]="800"
              customClass="fs-small"
              [isLoading]="editIsSaving" [disabled]="editIsSaving"
              [text]="'buttons.save'|translate" (click)="saveEdit(note)"></app-gray-button>
          </div>
        </ng-container>
      </div>

      <div class="text-center py-4" *ngIf="!isLoading && !notes.length">
        <p class="fs-small fw-800 color-gray-950 mb-1">{{'students.meeting_notes.private.empty_title'|translate}}</p>
        <p class="fs-small fw-400 color-gray-400 mb-0">{{'students.meeting_notes.private.empty_desc'|translate}}</p>
      </div>

      <app-gray-button
        class="d-block mt-3" *ngIf="hasMore()"
        color="stroke" [weight]="500" padding="py-2" customClass="fs-small"
        [isLoading]="isLoading" [disabled]="isLoading"
        [text]="'students.meeting_notes.private.load_more'|translate" (click)="loadMore()"></app-gray-button>
    </div>
  </div>

</div>
